export const events = {
  processOverviewOpened: 'Process overview opened',
  processConfigOpened: 'Process config opened',
  processInstancePageOpened: 'Process instance page opened',
  processTaskDetailOpened: 'Process task detail opened',
  processTaskSaved: 'Task saved',
  processTaskCreationOpened: 'Task creation opened',
  processTaskDeleted: 'Task deleted',
  processTaskCreated: 'Task created',
  processIntanceAdded: 'Process instance added',
  processCreated: 'Process created',
  upgradePlanOpened: 'Upgrade plan opened',
  upgradePlanContactSuccessful: 'Upgrade plan contact successful',
  workflowsPageOpened: 'Workflows page opened',
  newCustomWorkflowStarted: 'New custom workflow started',
  newCustomWorkflowSaved: 'New custom workflow saved',
  newTemplateWorkflowStarted: 'New template workflow started',
  newTemplateWorkflowSaved: 'New template workflow saved',
  actionUpsellClicked: 'Action upsell clicked',
  actionUpsellClosed: 'Action upsell closed',
  actionUpsellSuccess: 'Action upsell success',
  createActionStarted: 'Create action started',
  createActionSaved: 'Create action saved wizard',
  taskTypeWizardSelected: 'Task type wizard selected',
  duplicateStepCreated: 'Duplicate step created',
  sendTaskReminderFromOverview: 'Send task reminder from overview',
}
